import PATH from "constants/path";
import React, { useEffect } from "react";
import { formatJapanDate, mapPreference,setCookie } from "utils/common";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { getUser } from "features/User/userSlice";
import { SERVICE } from "constants/global";
import { Notice } from "components";

function Info() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { user, noticesInit } = useSelector((state) => state.user);
  useEffect(() => {
    if (!user) {
      dispatch(getUser());
    }
  }, []);

  if (!user) return null;

  return (
    <div className="w-80 py-0 py-md-3">
      <Notice noticesInit={noticesInit} />

      <div className="fs-20 fs-sm-18 fw-600 my-3 my-md-4 text-center">
        会員情報
      </div>

      <div className="px-3 px-md-0">
        <table className="table-view border-0 border-radius-0 bg-grey my-3 w-100">
          <tbody>
            <tr>
              <td className="bg-grey fs-14 fw-600 ps-3">会員番号</td>
              <td className="ps-2 ps-md-3">{user?.id}</td>
            </tr>
          </tbody>
        </table>
        <table className="table-view my-3 border-radius-0 border-radius-sm-5 w-100">
          <tbody>
            <tr>
              <td className="fs-14 fw-600 ps-3">お名前</td>
              <td className="ps-2 ps-md-3">
                {user?.last_name} {user?.first_name}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">お名前 (カナ)</td>
              <td className="ps-2 ps-md-3">
                {user?.last_name_kana} {user?.first_name_kana}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">性別</td>
              <td className="ps-2 ps-md-3">
                {["","男性", "女性"][user?.gender] || ''}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">生年月日</td>
              <td className="ps-2 ps-md-3">
                {formatJapanDate(user?.birth_date)}
              </td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">郵便番号</td>
              <td className="ps-2 ps-md-3">{user?.post_code}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">都道府県</td>
              <td className="ps-2 ps-md-3">{mapPreference(user?.pref_code)}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">市区町村</td>
              <td className="ps-2 ps-md-3">{user?.city_name || "ー"}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">地名番地</td>
              <td className="ps-2 ps-md-3">{user?.address1 || "ー"}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">建物名・部屋番号</td>
              <td className="ps-2 ps-md-3">{user?.address2 || "ー"}</td>
            </tr>
            <tr>
              <td className="fs-14 fw-600 ps-3">携帯電話番号</td>
              <td className="ps-2 ps-md-3">{user?.phone}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="group-btn-update my-4 my-md-5 px-3 px-md-0">
        <div onClick={() => history.push(PATH.SETTING)} className="btn-update">
          戻る
        </div>
        <div
          onClick={() => {
            window.location = `${PATH.COMMON}${PATH.UPDATE_INFO.EDIT}?service=${SERVICE}&url_back=${window.location.href}`;
          }}
          className="btn-update red-light"
        >
          変更する
        </div>
      </div>
    </div>
  );
}

export default Info;
